import React, { useMemo } from "react";
import { appealRequestForm } from "../../../shared/formObjects/application/appealRequestForm";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

export default function AppealRequestComponent({ disabled, data, showBack = false }: any) {
  const {
    application: { nextApplicationId, hasAppeal },
    applicationBase,
    id,
  } = useApplicationContext();

  const context = useMemo(() => {
    return {
      nextApplicationId,
      hasAppeal,
      discriminator: applicationBase.discriminator,
    };
  }, []);

  return (
    <>
      {applicationBase.assignStatus?.status == "Finalised" && (
        <BaseApplicationComponent
          formBody={appealRequestForm}
          headerLabel="Appeal Request"
          editPath="appealRequest"
          apiClient={useApiClient("AppealRequestCurrent")}
          disabled={disabled || hasAppeal}
          showInternalNotes={false}
          formContext={context}
          data={data}
          showBack={showBack}
          showEdit={!hasAppeal}
          id={id}
        />
      )}
    </>
  );
}
